import PropTypes from "prop-types";
import React from "react";
import { sealBlue } from "@govlaunch/palette";

export default function TypeaheadTextInput({ inputRef, ...props }) {
  return (
    <input spellCheck={false} autoComplete="off" css={inputStyle} style={overrideStyle} ref={inputRef} {...props} />
  );
}

TypeaheadTextInput.propTypes = {
  inputRef: PropTypes.any,
};

TypeaheadTextInput.defaultProps = {
  inputRef: () => {},
};

const inputStyle = {
  boxSizing: "border-box",
  flex: "1 1 auto",
  width: "100%",
  height: "100%",
  letterSpacing: 0.5,
  lineHeight: 1.14,
  fontWeight: 500,
  fontSize: 14,
  "::placeholder": {
    color: sealBlue,
  },
  outline: 0,
  paddingLeft: 20,
  paddingRight: 20,
  backgroundColor: "transparent",
  border: "1px solid transparent",
};

const overrideStyle = {
  boxShadow: "none",
};
